import { reflect } from '@effector/reflect';
import { Textarea } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { gameModel } from 'entities/game';
import { fairnessModalModel } from '../../model';
import { FairnessModalMines } from '../fairness-modal-mines';
import cls from './fairness-modal-verify.module.scss';

const ClientSeedField = reflect({
	view: Textarea,
	bind: {
		readOnly: fairnessModalModel.$clientSeedFieldReadOnly,
		value: gameModel.$clientSeed,
		onChange: (e) => fairnessModalModel.clientSeedChanged(e.target.value),
	},
});

const MinesField = reflect({
	view: Textarea,
	bind: {
		value: fairnessModalModel.$mines.map((mines) =>
			mines.map((level) => level.join(',')).join('.'),
		),
		readOnly: true,
	},
});

const ServerSeedField = reflect({
	view: Textarea,
	bind: {
		value: fairnessModalModel.$serverSeed,
		readOnly: true,
	},
});

const MaskField = reflect({
	view: Textarea,
	bind: {
		value: fairnessModalModel.$mask,
		readOnly: true,
	},
});

const ProvablyFairField = reflect({
	view: Textarea,
	bind: {
		value: fairnessModalModel.$provablyFair,
		readOnly: true,
	},
});

export const FairnessModalVerify = () => {
	const { t } = useTranslation();

	return (
		<div
			data-scroll
			className={cls.fairnessModalVerify}
		>
			<FairnessModalMines />
			<form
				className={cls.fairnessModalVerifyForm}
				onSubmit={(event) => {
					event.preventDefault();
				}}
			>
				<ClientSeedField
					variant='secondary'
					label={t('fairness-modal.client-seed')}
				/>
				<MinesField
					variant='secondary'
					label={t('fairness-modal.mines')}
					placeholder={t('fairness-modal.verify.appear-end')}
				/>
				<ServerSeedField
					variant='secondary'
					label={t('fairness-modal.server-seed')}
					placeholder={t('fairness-modal.verify.appear-end')}
				/>
				<MaskField
					variant='secondary'
					label={t('fairness-modal.mask')}
					placeholder={t('fairness-modal.verify.combined')}
				/>
				<ProvablyFairField
					variant='secondary'
					label={t('fairness-modal.provably-fair')}
					placeholder={t('fairness-modal.verify.appear-start')}
				/>
			</form>
		</div>
	);
};
